module.exports = __webpack_public_path__ + "img/covid_cases_27522R.0ebe7aab.jpg";